import React from "react";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  itemName?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "Do you really want to delete these records? This process cannot be undone.",
  itemName,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center",
            fontFamily: "karbon-medium",
          }}
        >
          {/* Commented out close button - matching your structure */}
          {/* <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "end",
            }}
          >
            <i
              style={{
                fontSize: "26px",
                color: "black",
                cursor: "pointer",
              }}
              className="bi bi-x"
              onClick={onClose}
            ></i>
          </div> */}
          <div style={{ color: "#3071e4", fontSize: "18px" }}>Are you sure?</div>
      <div style={{ marginBottom: "15px", fontSize: "16px" }}>
        Do you really want to delete these records? This process cannot be
        undone.
      </div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <button
          style={{
            color: "white",
            background: "#F25D21",
            border: "none",
            padding: "10px 15px",
            borderRadius: "20px",
          }}
          onClick={handleConfirm}
        >
          Delete
        </button>
        <button className="btn btn-light" onClick={onClose}>
          Cancel
        </button>
      </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
